import React from 'react';
import { apvIa } from '../services/api';
import AnalyseIaRapport from './AnalyseIaRapport';

// ─── Analyse IA de l'atelier — panneau latéral d'APV — Performance ──────────
// Auto Antilles (2026-10-04), sur la période du rapport : heures vendues, taux
// horaire, mix, objectifs, panier atelier, OR en cours. Mécanique commune :
// AnalyseIaRapport.
export default function ApvAnalyseIa({ libellePeriode, ...props }) {
  return (
    <AnalyseIaRapport {...props} api={apvIa} titre="Analyse IA de l'atelier" prefixeFichier="analyse-atelier"
      sousTitre={`Auto Antilles · ${libellePeriode} contre la même période N-1 · concessions pseudonymisées, aucun client ni réceptionnaire`} />
  );
}
